module.exports = __webpack_public_path__ + "img/single-neutral-actions-refresh.e202bbe8.svg";